import { useCallback, useMemo, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

const DEFAULT_PAGE = 1;
const CATEGORIES_KEY = 'categories[]';

export function useFilterHandlers() {
  const wereFiltersUsed = useRef(false);
  const [filters, setFilters] = useSearchParams({
    page: DEFAULT_PAGE,
    [CATEGORIES_KEY]: [],
  });

  const currentPage = useMemo(
    () => parseInt(filters.get('page'), 10),
    [filters],
  );
  const selectedCategories = useMemo(
    () => filters.getAll(CATEGORIES_KEY),
    [filters],
  );

  const changeWereFilterUsed = useCallback(() => {
    if (!wereFiltersUsed.current) {
      wereFiltersUsed.current = true;
    }
  }, []);

  const handleCategoriesChange = useCallback(
    (selectedCategories) => {
      changeWereFilterUsed();

      setFilters((params) => {
        // when category is changed, return to first page
        params.set('page', 1);
        params.delete(CATEGORIES_KEY);

        selectedCategories.forEach((categoryId) => {
          params.append(CATEGORIES_KEY, categoryId);
        });

        return params;
      });
    },
    [changeWereFilterUsed, setFilters],
  );

  const handlePageChange = useCallback(
    (page) => {
      changeWereFilterUsed();

      setFilters((params) => {
        params.delete('page');
        params.set('page', page);

        return params;
      });
    },
    [changeWereFilterUsed, setFilters],
  );

  return {
    currentPage,
    selectedCategories,
    wereFiltersUsed: wereFiltersUsed.current,
    handleCategoriesChange,
    handlePageChange,
  };
}
